module.exports = __webpack_public_path__ + "static/media/e1b.72d31d98.jpg";